import type { SymbolRenderProps } from '../types';

const TIP_LENGTH = 2;
const TIP_HALF_HEIGHT = 1.2;
const SHAFT_WIDTH = 0.3;
const SHAFT_OFFSET = 0.8;

export function ArrowEquilibrium({ shaftLength }: SymbolRenderProps) {
  const halfShaft = shaftLength / 2;

  return (
    <g>
      {/* Forward arrow (top) */}
      <line
        x1={-halfShaft} y1={-SHAFT_OFFSET}
        x2={halfShaft - TIP_LENGTH} y2={-SHAFT_OFFSET}
        stroke="black" strokeWidth={SHAFT_WIDTH}
      />
      <polygon
        points={`${halfShaft},${-SHAFT_OFFSET} ${halfShaft - TIP_LENGTH},${-SHAFT_OFFSET - TIP_HALF_HEIGHT} ${halfShaft - TIP_LENGTH},${-SHAFT_OFFSET + TIP_HALF_HEIGHT}`}
        fill="black"
      />
      {/* Reverse arrow (bottom) */}
      <line
        x1={halfShaft} y1={SHAFT_OFFSET}
        x2={-halfShaft + TIP_LENGTH} y2={SHAFT_OFFSET}
        stroke="black" strokeWidth={SHAFT_WIDTH}
      />
      <polygon
        points={`${-halfShaft},${SHAFT_OFFSET} ${-halfShaft + TIP_LENGTH},${SHAFT_OFFSET - TIP_HALF_HEIGHT} ${-halfShaft + TIP_LENGTH},${SHAFT_OFFSET + TIP_HALF_HEIGHT}`}
        fill="black"
      />
    </g>
  );
}
